import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'allAgentsButton'
	| 'starredAgentsButton'
	| 'myAgentsButton'
	| 'verifiedAgentsButton'
	| 'verifiedAgentsButtonM1'
	| 'templatesButton'
	| 'createAgentButton'
	| 'createAgentRefreshButton'
	| 'closeButton'
	| 'createButtonDisabledTooltip';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		allAgentsButton: {
			id: 'rovo-chat.browse-agents.all-agents-button',
			defaultMessage: 'All',
			description: 'Tab button in the browse agents panel to show all available agents',
		},
		starredAgentsButton: {
			id: 'rovo-chat.browse-agents.favorite-agents-button',
			defaultMessage: 'Favorites',
			description: 'Button to show favorite agents',
		},
		myAgentsButton: {
			id: 'rovo-chat.browse-agents.my-agents-button',
			defaultMessage: 'My agents',
			description: 'Button to show agents created by the user',
		},
		verifiedAgentsButton: {
			id: 'rovo-chat.browse-agents.verified-agents-button',
			defaultMessage: 'Verified agents',
			description: 'Button to show verified agents',
		},
		verifiedAgentsButtonM1: {
			id: 'rovo-chat.browse-agents.verified-agents-button-m1',
			defaultMessage: 'Verified',
			description: 'Tab button in the browse agents panel to show verified agents',
		},
		templatesButton: {
			id: 'rovo-chat.browse-agents.templates-button',
			defaultMessage: 'Templates',
			description: 'Button to show templates created by the user',
		},
		createAgentButton: {
			id: 'rovo-chat.browse-agents.create-agent-button',
			defaultMessage: 'Create',
			description: 'Button to create a new agent, shown in the header',
		},
		createAgentRefreshButton: {
			id: 'rovo-chat.browse-agents.create-agent-button',
			defaultMessage: 'Create Agent',
			description: 'Button to create a new agent, shown in the header',
		},
		closeButton: {
			id: 'rovo-chat.browse-agents.close-button',
			defaultMessage: 'Close',
			description: 'Button to close the browse agents experience',
		},
		createButtonDisabledTooltip: {
			id: 'rovo-chat.browse-agents.create-button-disabled-tooltip',
			defaultMessage: "You don't have permission to create agents in this site",
			description:
				'Tooltip to show when the create agent button is disabled due to user not having rovo agent create permissions on the site',
		},
	});

export default message;
